import { useState } from 'react';
import '../assets/css/animated-buttons.css';

const AnimatedViewButton = ({ onClick, className = '', children = 'View Details' }) => {
  const [isActive, setIsActive] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent card click when clicking button
    setIsActive(true);

    setTimeout(() => {
      setIsActive(false);
    }, 1000);

    onClick(e);
  };

  return (
    <button
      className={`view-button ${isActive ? 'active' : ''} ${className}`}
      onClick={handleClick}
    >
      <span>{children}</span>
    </button>
  );
};

export default AnimatedViewButton;
